import { useSearchParams } from "react-router-dom";
import Seo from "@/lib/Seo";
import CareerForm from "@/components/CareerForm";
import SiaqLine from "@/components/SiaqLine";

export default function Careers() {
  const [params] = useSearchParams();
  const isCoop = params.get("type") === "coop";
  const title = isCoop ? "التدريب التعاوني في سياق" : "انضم إلى فريق سياق";
  const subtitle = isCoop
    ? "فرصة تدريب تعاوني لطلاب وطالبات الجامعات — أخبرنا عن تخصصك وميولك، ونعود إليك بالخطوة التالية."
    : "نبحث دائمًا عن خبرات وشغف يضاف إلى فريقنا. أخبرنا عنك، وسنعود إليك حين تتاح فرصة تناسبك.";

  return (
    <>
      <Seo
        path="/careers"
        title={title}
        description={subtitle}
      />
      <header
        className="relative bg-navy text-white pt-32 pb-16 overflow-hidden"
        style={{ backgroundColor: "var(--navy)" }}
      >
        <SiaqLine
          variant="flow"
          className="absolute bottom-0 inset-x-0 h-16 w-full opacity-70"
        />
        <div className="mx-auto max-w-[900px] px-6 sm:px-10 relative">
          <span className="eyebrow mb-5">فريق سياق</span>
          <h1
            className="font-display leading-tight"
            style={{ fontSize: "clamp(1.7rem, 3.3vw, 2.8rem)" }}
          >
            {title}
          </h1>
          <p className="mt-5 text-white/75 text-lg max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        </div>
      </header>
      <div className="bg-paper py-16">
        <div className="mx-auto max-w-[900px] px-6 sm:px-10">
          <CareerForm />
        </div>
      </div>
    </>
  );
}
